import React, { ReactNode } from "react";
import {
  KeyIcon,
  CreditCardIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import CreditCardForm from "./forms/CreditCardForm";
import DefaultForm from "./forms/DefaultForm";
import LoginForm from "./forms/LoginForm";
import { SecretFormProps } from "./types";

interface SecretType {
  value: string;
  label: string;
  icon: ReactNode;
  view: React.FC<SecretFormProps>;
}

export const DEFAULT_SECRET_TYPE = {
  value: "secret",
  label: "Other",
  icon: <DocumentTextIcon height="24px" width="24px" />,
  view: DefaultForm,
};

export const SECRET_TYPES: SecretType[] = [
  {
    value: "credit_card",
    label: "Credit Card",
    icon: <CreditCardIcon height="24px" width="24px" />,
    view: CreditCardForm,
  },
  {
    value: "login",
    label: "Password",
    icon: <KeyIcon height="24px" width="24px" />,
    view: LoginForm,
  },
  DEFAULT_SECRET_TYPE,
];

export const getSecretLabel = (valueType: string) => {
  const obj = SECRET_TYPES.find((cat) => cat.value === valueType);
  return obj ? obj.label : "";
};

export const TYPE_FILTER_OPTIONS = [
  { label: "All", value: "all" },
  ...SECRET_TYPES.map((t) => ({
    label: t.label,
    value: t.value,
  })),
];

export const SORT_OPTIONS = [
  { label: "Title A-Z", value: "title_asc", mutuallyExclusive: true as const },
  {
    label: "Title Z-A",
    value: "title_desc",
    mutuallyExclusive: true as const,
  },
  { label: "Newest", value: "newest", mutuallyExclusive: true as const },
  { label: "Oldest", value: "oldest", mutuallyExclusive: true as const },
];

export const DROPDOWN_SX = {
  "& .MuiSelect-select": {
    paddingLeft: "0px !important",
  },
};
